<script lang="ts">
  import { onDestroy, onMount } from 'svelte';
  import Button from './Button.svelte';

  export let countryCode: string = 'world';

  export let dataChart: Array<Array<any>>;

  export let options: {
    backgroundColor: string;
    displayMode: string;
    defaultColor: string;
    colorAxis: { colors: string[] };
    datalessRegionColor: string;
    tooltip: { isHtml: boolean; trigger: string };
    enableRegionInteractivity: boolean;
    region: string;
    legend: string;
  };

  let isMapZoomed = false;

  function unzoomMap() {
    isMapZoomed = false;
    drawChart('world');
  }

  function zoomToRegion(regionCode: string) {
    drawChart(regionCode);
  }

  async function drawChart(regionCode = countryCode) {
    let data = await window.google.visualization.arrayToDataTable(dataChart);
    let chart = new window.google.visualization.GeoChart(document.getElementById('regions_div'));
    options.region = regionCode;
    options.region === 'world' ? (isMapZoomed = false) : (isMapZoomed = true);
    chart.draw(data, options);

    window.google.visualization.events.addListener(chart, 'regionClick', function (event: any) {
      zoomToRegion(event.region);
      isMapZoomed = true;
    });
  }

  onMount(async () => {
    window.addEventListener('resize', () => drawChart());
    window.google.charts.load('current', { packages: ['geochart'] });
    options.region = countryCode;
    await window.google.charts.setOnLoadCallback(drawChart);
  });

  onDestroy(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', () => drawChart());
    }
  });
</script>

<div id="regions_div"></div>

{#if options.enableRegionInteractivity}
  <div class="position-absolute ml-3 mt-3" style="z-index: 1" class:d-none={!isMapZoomed}>
    <Button label="Unzoom Map" type="secondary" click={unzoomMap} icon="fa-solid fa-angle-left"
      ><span> Back to World Map</span></Button
    >
  </div>
{/if}
